#version 300 es
precision mediump float;
uniform sampler2D uBlurInput;
uniform vec2 uTexelSize;
uniform bool uHorizontal;
in vec2 vUV;
out vec4 fragColor;

// 9-tap Gaussian weights (sigma ≈ 2.0)
const float W[5] = float[](0.227027, 0.194595, 0.121622, 0.054054, 0.016216);

void main() {
  vec2 step = uHorizontal ? vec2(uTexelSize.x, 0.0) : vec2(0.0, uTexelSize.y);
  vec3 result = texture(uBlurInput, vUV).rgb * W[0];
  for (int i = 1; i < 5; i++) {
    float w = W[i];
    result += texture(uBlurInput, vUV + step * float(i)).rgb * w;
    result += texture(uBlurInput, vUV - step * float(i)).rgb * w;
  }
  fragColor = vec4(result, 1.0);
}
